import React from 'react';

import { PageMetaRepo } from 'domain/repositories';
import { Feedback, PageMeta } from 'domain/types';
import Layout from 'components/layout/Layout';
import Feedbacks from 'components/feedbacks/Feedbacks';
import { FeedbacksRepo } from 'domain/repositories/FeedbacksRepo';
import { REVALIDATES } from 'domain/constants';

interface Props {
  pageMeta: PageMeta;
  feedbacks: Feedback[];
}

const FeedbacksPage: React.FC<Props> = ({ pageMeta, feedbacks }): JSX.Element => {
  return (
    <Layout pageMeta={{ ...pageMeta, title: 'Відгуки' }}>
      <Feedbacks feedbacks={feedbacks} />
    </Layout>
  );
};

export const getStaticProps = async () => {
  try {
    const [pageMeta, feedbacks] = await Promise.all([
      PageMetaRepo.getDefault(),
      FeedbacksRepo.getAll()
    ]);

    return {
      props: {
        pageMeta,
        feedbacks
      },
      revalidate: REVALIDATES.feedback
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);

    return {
      notFound: true,
      revalidate: REVALIDATES.index
    };
  }
};

export default FeedbacksPage;
